import { Controller } from '@hotwired/stimulus'

// This controller shows/hides content based on a source element's value matching a specified match value.
// It also listens for autocomplete.change events to detect when a "new" item is selected
// and updates the isNewSchool hidden field accordingly.
//
// Usage:
// <div data-controller="conditional-render" data-conditional-render-match-value="true">
//   <input data-conditional-render-target="source" data-action="change->conditional-render#toggle">
//   <input data-conditional-render-target="isNewSchool" type="hidden">
//   <input data-conditional-render-target="schoolId" type="hidden" id="free_preview_enquiry_school_id">
//   <div data-conditional-render-target="content" class="hidden">
//     <!-- Content to show when condition matches -->
//   </div>
// </div>
export default class extends Controller {
  static targets = ['source', 'content', 'isNewSchool', 'schoolId']
  static values = { match: String }

  connect() {
    this.boundHandleAutocompleteChange = this.handleAutocompleteChange.bind(this)
    this.element.addEventListener('autocomplete.change', this.boundHandleAutocompleteChange)
    this.toggle()
  }

  disconnect() {
    this.element.removeEventListener('autocomplete.change', this.boundHandleAutocompleteChange)
  }

  handleAutocompleteChange(event) {
    const { selected } = event.detail
    const isNewSchool = selected?.getAttribute('data-allow-new') === 'true'
    const schoolId = selected?.getAttribute('data-school-id')

    if (this.hasIsNewSchoolTarget) {
      this.isNewSchoolTarget.value = isNewSchool ? 'true' : 'false'
    }

    if (this.hasSchoolIdTarget) {
      this.schoolIdTarget.value = schoolId || ''
    }

    this.toggle()
  }

  toggle() {
    if (!this.hasContentTarget) return

    const isMatch = this.hasIsNewSchoolTarget
      ? this.isNewSchoolTarget.value === this.matchValue
      : this.sourceTarget.value === this.matchValue

    if (isMatch) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.contentTarget.classList.remove('hidden')
  }

  hide() {
    this.contentTarget.classList.add('hidden')
  }
}
